<mvs-widget
  *ngIf="openTicketsWidget"
  [widgetData]="openTicketsWidget"
  [disableUpdate]="disableUpdate"
></mvs-widget>
